import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { MdAnnouncement } from "react-icons/md";
import { useSetRecoilState } from "recoil";

import { useUser } from "../../../Hooks/useUser";
import { Button } from "../../Button";
import { Tooltip } from "../../Tooltip";
import { DropdownNav } from "./DropdownNav";
import { NovuComponent } from "../../NovuComponent";
import { usePortal } from "MVVM/Hooks/usePortal";
import { SignatureSelectorModal } from "MVVM/Components/Signatures";
import { Avatar } from "MVVM/Components/AvatarV2";
import { TUserGroup, TUserRank } from "MVVM/@types";
import { AllstarModalState } from "MVVM/State/modals";
import { ModalType } from "MVVM/@types";

const excludedNext = ["/start"];

const AuthenticatedSection = () => {
  const { allstarUser } = useUser();
  const setAllstarModalState = useSetRecoilState(AllstarModalState);
  const {
    portalOpen: signatureSelectorOpen,
    setPortalOpen: setSignatureSelectorOpen,
    Portal: SignatureSelectorPortal,
  } = usePortal(
    <SignatureSelectorModal
      onSave={() => {
        setSignatureSelectorOpen(false);
      }}
      onCloseClick={() => {
        setSignatureSelectorOpen(false);
      }}
    />,
    "root",
  );
  const loginUrl = excludedNext.includes(window.location.pathname)
    ? "/login"
    : `/login?next=${window.location.pathname}`;

  if (!allstarUser.loggedIn)
    return (
      <Flex style={{ gap: 8 }}>
        <ResponsiveWrapper>
          <Button
            size="small"
            flex={true}
            classification="tertiary"
            to={loginUrl}
          >
            Login
          </Button>
        </ResponsiveWrapper>
        <Button size="small" flex={true} to="/register">
          Sign Up
        </Button>
      </Flex>
    );

  return (
    <Flex alignItems="center" style={{ gap: "24px" }}>
      {signatureSelectorOpen && SignatureSelectorPortal}
      <ResponsiveWrapper>
        <NovuComponent isExperiment={true} />
      </ResponsiveWrapper>
      <Flex alignItems="center" style={{ gap: "18px" }}>
        <InfoIconButton
          onClick={() => {
            setAllstarModalState({
              data: {},
              isOpen: ModalType.CreatorCreditsAnnouncement,
              functions: {},
            });
          }}
          title="Creator Credits Update"
        >
          <MdAnnouncement size={16} />
        </InfoIconButton>
        <Tooltip
          isVisible={false}
          type="click"
          tooltipContent={
            <DropdownNav
              openSignatureSelector={() => {
                setSignatureSelectorOpen(true);
              }}
            />
          }
          position={{ top: "44px", left: "-300px" }}
        >
          <Avatar
            src={allstarUser?.user?.avatar}
            size="sm"
            userGroup={allstarUser.user?.userGroup.type as TUserGroup}
            rank={allstarUser.user?.rank as TUserRank}
            style={{ cursor: "pointer" }}
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
};

const ResponsiveWrapper = styled(Box)`
  @media (max-width: ${(props) => props.theme.breaks.small}) {
    display: none;
  }
`;

const InfoIconButton = styled.button`
  align-items: center;
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  width: 32px;

  &:hover {
    opacity: 0.9;
    transform: scale(1.05);
  }

  &:active {
    opacity: 0.8;
    transform: scale(0.95);
  }
`;

export { AuthenticatedSection };
